import React from 'react';

import { ListingsContext } from '@kamernet/modules/Listing/context/ListingsContext';

import { SearchView } from '../../types';

export const useFilterSelectors = () => {
  const { listingsState } = ListingsContext.useContext();

  const isValidCity = React.useCallback(() => {
    return !!(
      listingsState.filterResult.filters.location?.cityName &&
      listingsState.filterResult.filters.location?.cityName.toLowerCase() !==
        'netherlands'
    );
  }, [listingsState.filterResult.filters.location?.cityName]);

  const getCityName = React.useCallback(() => {
    return (
      listingsState.filterResult.filters.location?.cityName || 'NETHERLANDS'
    );
  }, [listingsState.filterResult.filters.location?.cityName]);

  const getStreetName = React.useCallback(() => {
    return listingsState.filterResult.filters.streetName;
  }, [listingsState.filterResult.filters.streetName]);

  const isMapView = React.useCallback(() => {
    return listingsState.filterResult.filters.searchview === SearchView.Map;
  }, [listingsState.filterResult.filters.searchview]);

  const getFiltersCount = React.useCallback(() => {
    return listingsState.filterResult.count;
  }, [listingsState.filterResult.count]);

  const getFilters = React.useCallback(() => {
    return listingsState.filterResult.filters;
  }, [listingsState.filterResult.filters]);

  return {
    isValidCity,
    getCityName,
    getStreetName,
    isMapView,
    getFiltersCount,
    getFilters,
  };
};
